import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect, withColorRenderer, defaultRenderer } from '../common';

class LocalLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items,
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems,
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems,
    });
  }

  handleChange(selected) {
    this.props.updateSelectedOptions(selected);
    this.props.saveConfig();
  }

  render() {
    const { items, selectedItems } = this.state;
    let colorsEnabled = false;
    if (this.props.chart === 'cfd') {
      colorsEnabled = true;
    } else if (this.props.chart === 'ctb') {
      colorsEnabled = this.props.breakdownBy === 'lists';
    }

    return (
      <CustomMultiselect
        name={'Lists'}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
        itemRenderer={colorsEnabled ? withColorRenderer : defaultRenderer}
      />
    );
  }
}

LocalLists.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (vals) => dispatch(updateSelectedOptions('lists', vals)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    chart: state.filters.chart,
    items: state.filters.allLists,
    selectedItems: state.filters[chart].selectedLists,
    breakdownBy: state.filters[state.filters.chart].breakdownBy,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalLists);
export { connected as LocalLists };
